import { Component, Input } from '@angular/core';
import { isRenderingForMobileApp } from 'src/constants';
import { ETagProductNameMapping, ETagType, Tag } from '~models/gift-card.model';

@Component({
  selector: 'app-gift-card',
  templateUrl: './gift-card.component.html',
  styleUrls: ['./gift-card.component.scss'],
})
export class GiftCardComponent {
  public isMobileRender = isRenderingForMobileApp;

  @Input()
  public href: string[];

  @Input()
  public image;

  @Input()
  public brand;

  @Input()
  public cardAvailable: boolean;

  @Input()
  public tags: Tag[];

  @Input()
  public priorityImage: boolean;

  hasAvailableTag(): boolean {
    return !!this.tags?.length;
  }

  getCashbackText(): string {
    const cashbackPromo = this.tags?.find((t) => t.type === ETagType.CASHBACK);

    if (!cashbackPromo) return '';

    const promoProductInfo =
      cashbackPromo.products?.length === 1
        ? ` ${ETagProductNameMapping[cashbackPromo.products[0]]}`
        : '';

    const isLockedState = cashbackPromo.text === 'Cashback deal';

    if (isLockedState) {
      return `${promoProductInfo} cashback`;
    }

    return `${cashbackPromo.text}${promoProductInfo}`;
  }

  getPlainTagText(): string {
    const tag = this.tags?.find((t) => t.type === ETagType.PLAIN);

    return tag?.text;
  }
}
